import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "light" | "dark" | "auto";
  className?: string;
  showBackground?: boolean;
}

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-10 w-10", 
  lg: "h-16 w-16",
  xl: "h-20 w-20"
};

const imageSizeClasses = {
  sm: "h-10 w-10",
  md: "h-12 w-12", 
  lg: "h-20 w-20",
  xl: "h-24 w-24"
};

const Logo = ({
  size = "md",
  variant = "auto",
  className,
  showBackground = true // Always show white background by default
}: LogoProps) => {
  // Always use white/light background for the logo with minimal padding
  const backgroundClass = "bg-white/95 ring-2 ring-primary/20 rounded-lg p-1 shadow-lg";
    
  return (
    <div className={cn(
      "flex items-center justify-center",
      sizeClasses[size],
      backgroundClass,
      className
    )}>
      <img 
        src="/lovable-uploads/081b737d-d37f-49d9-94c1-336b9a3bca1d.png" 
        alt="HIBANE AI Logo" 
        className={cn("object-contain", imageSizeClasses[size])}
      />
    </div>
  );
};
export default Logo;